import type { LightAccessory, Product } from "@/features/sub-families/types";
import type { Nullable } from "@/types";

export const getAccessories = (product: Nullable<Product>) => {
    return product?.properties.light_acc ?? [];
};

export function getAccessoryByConfigCode(
    product: Nullable<Product>,
    configCode: Nullable<string>,
): Nullable<LightAccessory> {
    if (configCode === null) return null;

    return getAccessories(product).find((accessory) => accessory.code === configCode) ?? null;
}
